// components/Sidebar.js

import ElectionLive from "@/component/ElectionLive";
import { useWindowSize } from "@/hooks/useIsMobile";
import { useEffect, useMemo, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Fragment } from "react";

const LivePlayerCard = dynamic(() => import("../../LivePlayerCard"));
const AdSlotDesktop300x250 = dynamic(() =>
  import("@/component/Ads/AdSlotDesktop300x250")
);
const TrendingTopic = dynamic(() => import("./TrendingTopic"));
const NewsList = dynamic(() => import("./NewsList"));
const NewsList2 = dynamic(() => import("./NewsList2"));
// const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));

export default function Sidebar({
  rightSideBarData = null,
  liveVideoData = null,
  topicListData = null,
  latestVideoData = null,
  latestStoryData = null,
  // isMobileDevice = false,
  electionLiveData = null,
}) {
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP = router?.asPath?.includes("/uttar-pradesh");
  const isUK = router?.asPath?.includes("/uttarakhand");
  const [isScroll, setIsScroll] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!isScroll) {
        setIsScroll(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScroll]);
  const size = useWindowSize();
  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, []);
  // const router = useRouter();
  return (
    <aside className="hidden md:block h-full right-0 min-h-screen border-l-[1px] px-2 py-4">
      {liveVideoData && liveVideoData?.live_id && (
        <LivePlayerCard liveData={liveVideoData} />
      )}
      {
        <div className="top-layer-election" style={{ position: "sticky" }}>
          <ElectionLive
            electionLiveData={electionLiveData?.content}
            firstActive={firstActive}
          />
        </div>
      }

      {topicListData &&
        topicListData?.content &&
        topicListData?.content?.length > 0 && (
          <TrendingTopic topicListData={topicListData} />
        )}

      {latestStoryData && latestStoryData?.content && (
        <>
          {/* {size.width !== undefined &&
            (size.width < 900 ? (
              <></>
            ) : (
              <div className="my-2">
                <AdSlot300x250
                  divId={"div-gpt-ad-1702014298509-1"}
                  minWidth="300px"
                  minHeight="250px"
                />
              </div>
            ))} */}
          <AdSlotDesktop300x250
            divId={"div-gpt-ad-1707804176041-1"}
            minWidth="300px"
            minHeight="250px"
          />
          <NewsList2
            isScroll={isScroll}
            contentData={latestStoryData}
            title="ट्रेंडिंग न्यूज़"
            isRajasthan={isRajasthan}
            isMadhya={isMadhya}
            isHR={isHR}
            isBH={isBH}
            isUP={isUP}
            isUK={isUK}
          />
        </>
      )}
      {latestVideoData && latestVideoData?.content && (
        <div className="sticky top-[70px]">
           
          <NewsList2
            isScroll={isScroll}
            contentData={latestVideoData}
            title="ट्रेंडिंग वीडियो"
            isRajasthan={isRajasthan}
            isMadhya={isMadhya}
            isHR={isHR}
            isBH={isBH}
            isUP={isUP}
            isUK={isUK}
          />
          
        </div>
      )}
      {/** map right side data by component type */}
      {rightSideBarData?.right?.map((item, index) => {
        return (
          // <section key={index} className="">
          <Fragment key={index}>
            {index === 0 &&
              (!latestStoryData ||
                !latestStoryData?.content ||
                latestStoryData?.content?.length === 0) &&
              size.width !== undefined && (
                // (size.width < 900 ? (
                //   <></>
                // ) : (
                //   index === 1 && (
                //     <div className="my-2">
                //       <AdSlot300x250
                //         divId={"div-gpt-ad-1702014298509-1"}
                //         minWidth="300px"
                //         minHeight="250px"
                //       />
                //     </div>
                //   )
                // ))
                <AdSlotDesktop300x250
                  divId={"div-gpt-ad-1707804176041-1"}
                  minWidth="300px"
                  minHeight="250px"
                />
              )}
            {item[0]?.widget_name === "uptak_rhs_listing" &&
              item[0]?.content?.length > 0 &&
              (rightSideBarData?.right?.length === index + 1 ? (
                <section key={index} className=" top-[70px]">
                  
                  {isScroll && (
                    <AdSlotDesktop300x250
                      divId={"div-gpt-ad-1751005897683-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />
                  )}
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                  {isScroll && (
                    <AdSlotDesktop300x250
                      divId={"div-gpt-ad-1751005897683-1"}
                      minWidth="300px"
                      minHeight="250px"
                    />
                  )}
                </section>
              ) : (
                <section key={index}>
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ))}
            {item[0]?.widget_name === "recommended_topics" &&
              item[0]?.content?.length > 0 &&
              (rightSideBarData?.right?.length === index + 1 ? (
                <section key={index} className="sticky top-[98px]">
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ) : (
                <section key={index}>
                  <NewsList isScroll={isScroll} contentData={item[0]} />
                </section>
              ))}
            {item[0]?.widget_name === "recommended_story" &&
              item[0]?.content?.length > 0 &&
              (rightSideBarData?.right?.length === index + 1 ? (
                <section key={index} className="sticky top-[98px]">
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ) : (
                <section key={index}>
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ))}
            {item[0]?.widget_name === "recommended_video" &&
              item[0]?.content?.length > 0 &&
              (rightSideBarData?.right?.length === index + 1 ? (
                <section key={index} className="sticky top-[98px]">
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ) : (
                <section key={index}>
                  <NewsList
                    isScroll={isScroll}
                    contentData={item[0]}
                    isRajasthan={isRajasthan}
                    isMadhya={isMadhya}
                    isHR={isHR}
                    isBH={isBH}
                    isUP={isUP}
                    isUK={isUK}
                  />
                </section>
              ))}
          </Fragment>
          // </section>
        );
      })}
    </aside>
  );
}
